// LLM & Cost settings — provider defaults banner + budget config + spend table.
import { createFileRoute } from "@tanstack/react-router";
import { useIsOrgAdmin } from "@/stores";
import { ProviderDefaultsBanner } from "@/features/settings/llm-cost/components/ProviderDefaultsBanner";
import { BudgetSettingsCard } from "@/features/settings/llm-cost/components/BudgetSettingsCard";

function LlmCostSection() {
  const canEdit = useIsOrgAdmin();

  return (
    <div className="space-y-6">
      <ProviderDefaultsBanner canEdit={canEdit} />
      <BudgetSettingsCard canEdit={canEdit} />
    </div>
  );
}

export const Route = createFileRoute("/_admin/settings/llm-cost")({
  component: LlmCostSection,
});
